module.exports = __webpack_public_path__ + "static/media/team-introduction-4.1b1dc94f.jpg";